/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type WorksheetStudier_viewer = {
    readonly user: {
        readonly id: string;
    } | null;
    readonly " $refType": "WorksheetStudier_viewer";
};
export type WorksheetStudier_viewer$data = WorksheetStudier_viewer;
export type WorksheetStudier_viewer$key = {
    readonly " $data"?: WorksheetStudier_viewer$data;
    readonly " $fragmentRefs": FragmentRefs<"WorksheetStudier_viewer">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "WorksheetStudier_viewer",
  "type": "Viewer",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "user",
      "storageKey": null,
      "args": null,
      "concreteType": "User",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "id",
          "args": null,
          "storageKey": null
        }
      ]
    }
  ]
};
(node as any).hash = '81a17b17a292e7f5b94fe7861bd976e0';
export default node;
